<template>
  <v-dialog v-model="visible" persistent max-width="800px">
    <v-card>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-icon large @click="close()">mdi-close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="8">
              <h1 class="text-h5 font-weight-regular pb-4">
                {{ $t("login.cambioExitosoTitle") }}
              </h1>
              <p class="py-5">
                {{ $t("login.cambioExitoso") }}
              </p>
              <v-row> </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="card-action-with-space">
        <v-spacer></v-spacer>

        <v-btn
          :style="`color: ${entityConfig.secondaryColor}`"
          @click="close()"
          depressed
          :color="entityConfig.primaryColor"
          class="btn rectangle-button-2 btn float-end m-2"
        >
          {{ $t("login.aceptar") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["visible"],
  data() {
    return {
      entityConfig: {},
      form: {},
    };
  },

  mounted() {
    setTimeout(() => {
      this.entityConfig = this.$store.state.entityConfig.config;
    }, 1000);
    this.form.codNrbeEn = sessionStorage.getItem("codNrbeEn");
  },

  methods: {
    close() {
      this.$emit("closed");
      this.$router.push({ path: "/" });
    },
    save(data) {
      this.$emit("saved", data);
      this.$router.push({ path: "/" });
    },
  },
};
</script>
